<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="card card-custom">
        <div class="card-header">
            <div class="card-title">
                        <span class="card-icon">
                            <i class="fa fa-ticket-alt text-aqua"></i>
                        </span>
                <h3 class="card-label text-uppercase">My Tickets</h3>
            </div>
        </div>
        <div class="card-body">
            <template>
                <div class="">
                    <v-data-table
                        dense
                        :headers="getCompanyInfo.id==1 ? headers2 : headers"
                        :items="tickets"
                        :page.sync="page"
                        :loading="loading"
                        :items-per-page="itemsPerPage"
                        class="elevation-1 table-bordered table-striped"
                        :footer-props="{
                          showFirstLastPage: true,
                          firstIcon: 'fa fa-angle-double-left',
                          lastIcon: 'fa fa-angle-double-right',
                          prevIcon: 'fa fa-angle-left',
                          nextIcon: 'fa fa-angle-right',
                          itemsPerPageText: 'Ticket per page: '
                        }"
                    >
                        <template v-if="getCompanyInfo.id==1" v-slot:item.paribahan="{item}">
                          <div>{{item.company_name}}</div>
                        </template>
                        <template  v-slot:item.info="{ item }">
                            <div class="text-left mb-1">
                                <span>{{item.boarding_station}} -> {{item.dropping_station}}</span>
                            </div>
                            <b-badge class="w-100 mb-1" variant="danger">
                                {{ item.coach_number}}
                            </b-badge>
                            <b-badge v-if="item.vehicle_type_id==1" class="w-100 mb-1" variant="success">
                                {{ item.vehicle_type_name}}
                            </b-badge>
                            <b-badge v-if="item.vehicle_type_id==2" class="w-100 mb-1" variant="warning">
                                {{ item.vehicle_type_name}}
                            </b-badge>
                        </template>
                        <template v-slot:item.passenger="{item}">
                            <div>{{item.passenger_name}}</div>
                            <div class="text-black-50">{{item.passenger_mobile}}</div>
                        </template>
                        <template v-slot:item.seats="{item}">
                            <div>{{item.seat_numbers}}</div>
                        </template>
                        <template v-slot:item.fare="{item}">
                            <div>{{item.grand_total}}</div>
                        </template>
                        <template v-slot:item.booking="{ item }">
                            {{item.booked_at ? moment(item.booked_at,"yyyy-MM-DD hh:mm:ss").format('D MMM yyyy hh:mm A') : moment(item.issued_at,"yyyy-MM-DD hh:mm:ss").format('D MMM yyyy hh:mm A')}}
                        </template>
                        <template v-slot:item.journey="{ item }">
                            <span class="text-success">{{moment(item.boarding_counter_time,"yyyy-MM-DD hh:mm:ss").format('D MMM yyyy hh:mm A')}}</span>
                        </template>
                        <template v-slot:item.status="{ item }" class="text-center">
                            <b-badge class="text-capitalize" v-if="item.status=='booked'" pill variant="warning">{{ item.status}}</b-badge>
                            <b-badge class="text-capitalize" v-if="item.status=='issued'" pill variant="success">{{ item.status}}</b-badge>
                            <b-badge class="text-capitalize" v-if="item.status=='cancelled' && item.issued_at==null" pill variant="danger">Expired</b-badge>
                            <b-badge class="text-capitalize" v-if="item.status=='cancelled' && item.issued_at!=null" pill variant="info">{{ item.status}}</b-badge>
                            <br/>
                            <small v-if="item.status=='booked'">{{moment(item.booked_at,"yyyy-MM-DD hh:mm:ss").format('D MMM yyyy hh:mm A')}}</small>
                            <small v-if="item.status=='issued'">{{moment(item.issued_at,"yyyy-MM-DD hh:mm:ss").format('D MMM yyyy hh:mm A')}}</small>
                            <small v-if="item.status=='cancelled'">{{moment(item.cancelled_at,"yyyy-MM-DD hh:mm:ss").format('D MMM yyyy hh:mm A')}}</small>
                        </template>
                        <template v-slot:item.view="{ item }">
                            <router-link :to="{name:'ticket-details',params:{id:item.id}}"> <v-chip class="bg-blue" style="cursor: pointer;">View</v-chip></router-link>
                        </template>
                    </v-data-table>
                </div>
            </template>
            <!--<div class="text-center">
                <v-pagination
                        v-model="page"
                        @input="getTicketList(page,itemsPerPage)"
                        :length="pageCount"
                ></v-pagination>
                <v-text-field
                        :value="itemsPerPage"
                        label="Items per page"
                        type="number"
                        @input="itemsPerPage = parseInt($event, 10)"
                ></v-text-field>
            </div>-->
        </div>
    </div>
</template>
<style lang="scss">
    tbody {
        tr:hover {
            background-color: #e0efff !important;
        }
    }
    .v-data-footer__select {
        margin-right: 30px !important;
    }
</style>

<script>
    import profileService from "@/core/services/models/profile.service"
    import {mapGetters} from "vuex";

    export default {
        name: "MyTickets",
        data () {
            return {
                page: 1,
                pageCount: 0,
                itemsPerPage: 5,
                loading:true,
                headers: [
                    {text : '#', value : 'sl', value:'id'},
                    {text : 'Coach Info', value : 'info'},
                    {text : 'Passenger', value : 'passenger'},
                    {text : 'Seats', value : 'seats'},
                    {text : 'Fare', value : 'fare'},
                    {text : 'Book/Issue Time', value : 'booking'},
                    {text : 'Journey Time', value : 'journey'},
                    {text : 'Status', value : 'status'},
                    {text : 'View', value : 'view'},
                ],
                headers2: [
                  {text : '#', value : 'sl', value:'id'},
                  {text : 'Paribahan', value : 'paribahan'},
                  {text : 'Coach Info', value : 'info'},
                  {text : 'Passenger', value : 'passenger'},
                  {text : 'Seats', value : 'seats'},
                  {text : 'Fare', value : 'fare'},
                  {text : 'Book/Issue Time', value : 'booking'},
                  {text : 'Journey Time', value : 'journey'},
                  {text : 'Status', value : 'status'},
                  {text : 'View', value : 'view'},
                ],
                tickets: [],
            }
        },
        computed:{
          ...mapGetters(['getCompanyInfo']),
        },
        methods:{
            getTicketList(page,perPage){
                //console.log(`page ${page} perPage ${perPage}`);
                this.loading = true;
                this.tickets = [];
                profileService.getTicketList({page:page,perPage:perPage}, data =>{
                    this.page      = page;
                    this.tickets   = data.data;
                    this.pageCount = data.last_page;
                    this.loading = false;
                });
            }
        },
        mounted(){
            this.getTicketList(this.page,this.itemsPerPage);
        }
    }
</script>
